var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{class:_vm.selectClass,attrs:{"id":_vm.id,"options":_vm.options,"placeholder":_vm.placeholder,"value":_vm.value,"multiple":_vm.multiple,"taggable":"","clearable":"","label":"label","reduce":(option) => option.value,"create-option":_vm.createOption},on:{"input":(state) => _vm.$emit('input', state || null)}})
}
var staticRenderFns = []

export { render, staticRenderFns }